var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "medicine-edit" },
    [
      _c("page-layout", [
        _c(
          "div",
          { staticClass: "medicine-edit__tips" },
          [
            _c("van-icon", { attrs: { name: "info" } }),
            _c("span", [_vm._v("处方药需实名购药，平台严格保护用药人隐私")]),
          ],
          1
        ),
        _c("div", { staticClass: "medicine-edit__content" }, [
          _c("div", { staticClass: "medicine-edit__form" }, [
            _c("div", { staticClass: "medicine-edit__form-item" }, [
              _c("div", { staticClass: "medicine-edit__form-label" }, [
                _c("span", { staticClass: "required" }, [_vm._v("*")]),
                _vm._v("姓名"),
              ]),
              _c("div", { staticClass: "medicine-edit__form-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.name,
                      expression: "form.name",
                    },
                  ],
                  attrs: { type: "text", placeholder: "请输入姓名" },
                  domProps: { value: _vm.form.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "name", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "medicine-edit__form-item" }, [
              _c("div", { staticClass: "medicine-edit__form-label" }, [
                _c("span", { staticClass: "required" }, [_vm._v("*")]),
                _vm._v("手机号"),
              ]),
              _c("div", { staticClass: "medicine-edit__form-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.phone,
                      expression: "form.phone",
                    },
                  ],
                  attrs: {
                    type: "tel",
                    maxLength: "11",
                    placeholder: "请输入手机号",
                  },
                  domProps: { value: _vm.form.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "phone", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "medicine-edit__form-item" }, [
              _c("div", { staticClass: "medicine-edit__form-label" }, [
                _c("span", { staticClass: "required" }, [_vm._v("*")]),
                _vm._v("身份证号"),
              ]),
              _c("div", { staticClass: "medicine-edit__form-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.idCard,
                      expression: "form.idCard",
                    },
                  ],
                  attrs: { type: "text", placeholder: "请输入身份证号" },
                  domProps: { value: _vm.form.idCard },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "idCard", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm.showWeightField
              ? _c("div", { staticClass: "medicine-edit__form-item" }, [
                  _c("div", { staticClass: "medicine-edit__form-label" }, [
                    _vm.isWeightRequired
                      ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                      : _vm._e(),
                    _vm._v("体重"),
                  ]),
                  _c("div", { staticClass: "medicine-edit__form-input" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.weight,
                          expression: "form.weight",
                        },
                      ],
                      attrs: { type: "number", placeholder: "请输入体重(kg)" },
                      domProps: { value: _vm.form.weight },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "weight", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "medicine-edit__form-item",
                on: { click: _vm.toggleHealthInfo },
              },
              [
                _c("div", { staticClass: "medicine-edit__form-label" }, [
                  _vm._v("健康信息"),
                ]),
                _c("div", { staticClass: "medicine-edit__form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.formatMedicalHistory(_vm.form.healthInfo) ||
                          "请填写"
                      )
                    ),
                  ]),
                  _c("i", {
                    staticClass: "iconfont icon-arrow",
                    class: { "icon-arrow-up": _vm.showHealthInfo },
                  }),
                ]),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "medicine-edit__relation" }, [
          _c("div", { staticClass: "medicine-edit__relation-title" }, [
            _vm._v("关系标签"),
          ]),
          _c(
            "div",
            { staticClass: "medicine-edit__relation-tags" },
            _vm._l(_vm.relationTags, function (item) {
              return _c(
                "div",
                {
                  key: item.label,
                  staticClass: "medicine-edit__relation-tag",
                  class: { active: _vm.form.relation === item.label },
                  on: {
                    click: function ($event) {
                      _vm.form.relation = item.label
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("health-info", {
        attrs: { "health-data": _vm.form.healthInfo },
        on: { submit: _vm.handleHealthInfoSubmit },
        model: {
          value: _vm.showHealthInfo,
          callback: function ($$v) {
            _vm.showHealthInfo = $$v
          },
          expression: "showHealthInfo",
        },
      }),
      _c("fixed-button", {
        attrs: { text: "保存" },
        on: { emitEvent: _vm.handleSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }